import { sendToChat, telegram } from './telegram';

const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

/** Сохраняет файл на устройство пользователя. Никаких запросов к серверу. */
export function downloadFile(data: ArrayBuffer, name: string): void {
  const url = URL.createObjectURL(new Blob([data], { type: DOCX_MIME }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

/**
 * Отдаёт готовый документ: на сайте — скачиванием, в Telegram — сообщением в чат с ботом
 * (скачать файл из браузера внутри Telegram нельзя). Возвращает, что произошло.
 */
export async function deliverFile(data: ArrayBuffer, name: string, caption: string): Promise<'downloaded' | 'sent'> {
  if (!telegram()) {
    downloadFile(data, name);
    return 'downloaded';
  }
  await sendToChat(data, name, caption);
  return 'sent';
}
